// extracted by mini-css-extract-plugin
module.exports = {"defaultIconStyle":"az_Hk","fontSizeInherit":"az_Ik","fontSizeSmall":"az_Jk","fontSizeLarge":"az_Kk"};